import "./Dialog.css";
import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

import DoneIcon from "@mui/icons-material/Done";
import UndoIcon from "@mui/icons-material/Undo";
import { useState } from "react";
import { Get } from "../../../Common/WebRequest";
import "./Dialog.css";

function StudentsDialog({
  open,
  currBranchId,
  handleClose,
  handelCancel,
  selectedStudentsDefaultIds,
}) {
  const [studentsData, setStudentsData] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    (async () => {
      await loadStudents();
    })();
  }, [open]);

  async function loadStudents() {
    setStudentsData([]);
    if (currBranchId === 0) return;
    let res = await Get(
      "TrackerStudent/StudentNotInTrackerStudents/" + currBranchId
    );
    if (res.isSuccess) {
      setStudentsData(res.result);
      console.log("SelectedStudents::: ", selectedStudentsDefaultIds);
      setSelectionModel(selectedStudentsDefaultIds);
    }
  }

  function handleAdd() {
    var selectedRowsData = selectionModel.map((id) =>
      studentsData.find((row) => row.id === id)
    );

    selectedRowsData = selectedRowsData.map((student) => {
      return {
        ...student,
        branchId: currBranchId,
      };
    });
    /*const sortedRowsData = [...selectedRowsData].sort((a, b) =>
      b.studentName.localeCompare(a.studentName)
    );*/

    console.log("Student.Dialog.handleAdd::: ", selectedRowsData);
    handleClose(selectedRowsData);
  }
  function handleClosed() {
    handelCancel();
  }

  function DefinedToolbar() {
    return (
      <Box
        sx={{
          p: 0,
          pb: 0,
        }}
      >
        <GridToolbarContainer>
          <GridToolbarQuickFilter />
        </GridToolbarContainer>
      </Box>
    );
  }

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "studentName", headerName: "Schüler/in", width: 250 },
  ];

  return (
    <Dialog open={open} onClose={handleClosed}>
      <DialogTitle className="dialog-title-box">
        Schüler/in hinzufügen
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            width: "350px",
            height: "500px",
          }}
        >
          <DataGrid
            checkboxSelection={true}
            //disableRowSelectionOnClick
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={(newSelection) => {
              setSelectionModel(newSelection);
            }}
            rows={studentsData}
            columns={columns}
            getRowId={(row) => row.id}
            density="compact"
            slots={{ toolbar: DefinedToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            initialState={{
              ...studentsData.initialState,
              columns: {
                ...studentsData.initialState?.columns,
                columnVisibilityModel: {
                  id: false,
                },
              },
            }}
            disableColumnMenu
            disableColumnSelector
            hideFooterPagination={true}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleClosed}
          startIcon={<UndoIcon />}
        >
          Abbrechen
        </Button>
        <Button
          disabled={
            selectionModel.length === 0 &&
            selectedStudentsDefaultIds.length === 0
          }
          variant="contained"
          onClick={handleAdd}
          endIcon={<DoneIcon />}
        >
          Akzeptieren
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StudentsDialog;
